module.exports = __webpack_public_path__ + "img/edge_activites_surf.d79b4aec.svg";